import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "./Button";

const PreviousButtonStep = ({
  onPreviousStep,
  disabled = false,
  children,
  sx = {},
  fullWidth = false,
}) => {
  return (
    <Button
      disabled={disabled}
      fullWidth={fullWidth}
      sx={{ ...sx }}
      color="secondary"
      onClick={onPreviousStep}
      startIcon={<ArrowBackIcon />}
    >
      {children}
    </Button>
  );
};

export default PreviousButtonStep;
